import { render, staticRenderFns } from "./VerImagenes.vue?vue&type=template&id=83b8c20e&scoped=true"
import script from "./VerImagenes.vue?vue&type=script&lang=js"
export * from "./VerImagenes.vue?vue&type=script&lang=js"
import style0 from "./VerImagenes.vue?vue&type=style&index=0&id=83b8c20e&prod&scoped=true&lang=css"
import style1 from "./VerImagenes.vue?vue&type=style&index=1&id=83b8c20e&prod&lang=scss&scoped=true"
import style2 from "./VerImagenes.vue?vue&type=style&index=2&id=83b8c20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b8c20e",
  null
  
)

export default component.exports